import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const NationalCommunityFocusIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescNationalCommunityFocus">bowl with spoon</desc>
      <circle cx="100" cy="100" r="84.34" className="background"></circle>
      <path
        d="M99.53,56.86c-.67-.65-3.85-4.58-1.17-11.34,0,0-7.52,6.89-2.89,12,4.92,5.41,6.42,8.74,2.89,15.22C97.82,73.7,108.72,67.23,99.53,56.86Z"
        className="accent"
      ></path>
      <path
        d="M113.9,70.82c-.67-.65-3.85-4.58-1.17-11.34,0,0-7.51,6.88-2.88,12,4.91,5.41,6.41,8.74,2.88,15.21C112.2,87.66,123.09,81.18,113.9,70.82Z"
        className="accent"
      ></path>
      <path
        d="M87.16,68.82c-.67-.65-3.85-4.58-1.17-11.34,0,0-7.51,6.88-2.89,12C88,74.87,89.52,78.2,86,84.67,85.45,85.66,96.35,79.18,87.16,68.82Z"
        className="accent"
      ></path>
      <path
        d="M143.21,103.4a4.69,4.69,0,0,0-1.7-3.32c-1.75-1.67-4.78-3.19-8.78-4.48l-3.26,2.63-.52.4c6.81,1.71,11,4,11,6.55,0,3.75-9.12,7-22.43,8.57a157.76,157.76,0,0,1-18.3,1c-4.11,0-8.07-.14-11.81-.41-16.74-1.19-28.92-4.85-28.92-9.18,0-5.3,18.24-9.59,40.73-9.59a159.08,159.08,0,0,1,17.6.93,20.35,20.35,0,0,0,2.44-2.89c.21-.3.43-.59.65-.87A145.14,145.14,0,0,0,99.2,91.35c-20.09,0-37,3.69-42.3,8.73a4.65,4.65,0,0,0-1.7,3.32,3.08,3.08,0,0,0,.07.68,6.77,6.77,0,0,0-.07,1,7.46,7.46,0,0,0,.09,1.16c1.29,14.08,10.22,26.12,22.91,32.54V140A3.79,3.79,0,0,0,82,143.73h34.43A3.78,3.78,0,0,0,120.2,140v-1.16a43.24,43.24,0,0,0,15.73-13.4,38.92,38.92,0,0,0,7.19-19.14,7.46,7.46,0,0,0,.09-1.16,6.77,6.77,0,0,0-.07-1A3.08,3.08,0,0,0,143.21,103.4Z"
        className="accent"
      ></path>
      <path
        d="M148.91,75.84a3.4,3.4,0,0,0-4.79-.52l-20,16.08c-.23.18-.44.38-.66.57l-1.61,2c-.19.25-.38.5-.56.76a22.79,22.79,0,0,1-2.67,3.17l-.67.66-.28,0a30.52,30.52,0,0,1-4.13,3.21c-4.17-3.08-11.45-2.1-17.34,2.64a19.69,19.69,0,0,0-6.13,8.15c3.11.18,6.32.28,9.57.28a158.35,158.35,0,0,0,16.58-.84,10.4,10.4,0,0,0-.21-7.16A26.75,26.75,0,0,1,124.46,99a15.84,15.84,0,0,0,3.94-2.34l20-16.07A3.42,3.42,0,0,0,148.91,75.84Z"
        className="accent"
      ></path>
    </Icon>
  );
};

export default NationalCommunityFocusIcon;
